import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

// Customer-side notifications (bell icon in navbar) + FCM token registration.
// Mirrors the supportApi pattern — uses createAuthBaseQuery so 401s clear
// the local session.
export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Notification', 'UnreadCount'],
  endpoints: (builder) => ({
    // ─── Token management ───
    registerToken: builder.mutation({
      query: (body) => ({ url: '/notifications/token', method: 'POST', body }),
    }),
    unregisterToken: builder.mutation({
      query: (body) => ({ url: '/notifications/token', method: 'DELETE', body }),
    }),

    // ─── Bell list + read state ───
    listNotifications: builder.query({
      query: (limit = 20) => `/notifications?limit=${limit}`,
      providesTags: ['Notification', 'UnreadCount'],
    }),
    getUnreadCount: builder.query({
      query: () => '/notifications/unread-count',
      providesTags: ['UnreadCount'],
    }),
    markRead: builder.mutation({
      query: (id) => ({ url: `/notifications/${id}/read`, method: 'PATCH' }),
      invalidatesTags: ['Notification', 'UnreadCount'],
    }),
    markAllRead: builder.mutation({
      query: () => ({ url: '/notifications/read-all', method: 'PATCH' }),
      invalidatesTags: ['Notification', 'UnreadCount'],
    }),

    // Hard-delete a single notification.
    deleteNotification: builder.mutation({
      query: (id) => ({ url: `/notifications/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Notification', 'UnreadCount'],
    }),

    // Clear the entire notification history for the current user.
    deleteAllNotifications: builder.mutation({
      query: () => ({ url: '/notifications', method: 'DELETE' }),
      invalidatesTags: ['Notification', 'UnreadCount'],
    }),
  }),
});

export const {
  useRegisterTokenMutation,
  useUnregisterTokenMutation,
  useListNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkReadMutation,
  useMarkAllReadMutation,
  useDeleteNotificationMutation,
  useDeleteAllNotificationsMutation,
} = notificationsApi;
